import React, { PropsWithChildren, useEffect, useState } from 'react'
import { Button } from '../atom/Button'

import { setCookie } from '../../utils/common'
import { useCookies } from 'react-cookie'
import { isMobile } from 'react-device-detect'
import useGetPopupContent from 'hooks/query/useGetPopupContent'
import { useLocation } from 'react-router-dom'

export const HomePopup = () => {
  const [isPopupModal, setPopupModal] = useState<boolean>(true)
  const { data: popupContent } = useGetPopupContent()
  const [cookies, setCookies] = useCookies(['fast_cut_popup'])

  const { pathname } = useLocation()
  const movePath = (path: string) => {
    if (path) {
      window.open(path, '_blank')
    }
  }
  const handlePopup = () => {
    if (check) {
      setCookie('fast_cut_popup', 'true', 1)
    }
    setPopupModal(false)
  }
  const [check, setCheck] = useState(false)
  const [content, setContent] = useState(popupContent)
  useEffect(() => {
    // 쿠키가 없으면 팝업을 보여줌
    if (cookies.fast_cut_popup) {
      setPopupModal(false)
    }
  }, [cookies])

  useEffect(() => {
    if (popupContent) {
      setContent(popupContent)
    }
  }, [popupContent])

  if (!isPopupModal) return <></>

  return (
    <>
      {popupContent?.status &&
        !cookies?.fast_cut_popup &&
        isPopupModal &&
        pathname !== '/challenge' && (
          <div className="h-screen w-full fixed left-0 -top-6 flex flex-col justify-center items-center  text-center p-[40px] z-50 ">
            <div className="bg-white w-[315px] md:w-[482px] md:px-5 px-[10px] py-8  border rounded-[20px] overflow-y-auto flex flex-col gap-6 shadow-main ">
              <div>
                <p className="text-main text-[24px] font-bold">
                  {content?.title}
                </p>
              </div>

              <div>
                <p className="font-bold text-[18px] whitespace-pre-wrap">
                  {content?.description}
                </p>
              </div>

              {content?.imagePath && (
                <div
                  className="md:w-[440px]  w-[295px] md:h-[220px] h-[147px]"
                  onClick={() => {
                    movePath(content.url)
                  }}
                >
                  <img
                    src={content.imagePath}
                    alt="img"
                    className="md:w-[440px] w-[295px] md:h-[220px] h-[147px] rounded-[10px]"
                  />
                </div>
              )}

              {!isMobile && (
                <div className="bg-[#F6F8FB] py-3 flex flex-col">
                  <p className="text-[18px] leading-[24px]">
                    ❓궁금한 점은{`  `}
                    <a
                      className="text-href"
                      href="https://blog.fastseller.shop/fastclick_guide/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      패스트컷AI 블로그에서
                    </a>
                    <br />
                    앞으로 나올 기능을 먼저 확인해보세요!
                  </p>
                </div>
              )}

              <div className="flex justify-between">
                <div className="flex gap-2 items-center">
                  <input
                    type="checkbox"
                    className="w-5 h-5 rounded-[4px]"
                    onChange={() => {
                      setCheck((prev) => !prev)
                    }}
                    checked={check}
                  />
                  <span className="text-[#5E6068] text-[14px] md:text-base">
                    오늘 하루동안 보지 않기
                  </span>
                </div>
                <Button
                  className="bg-main text-white py-3 px-8 rounded-[10px] text-[14px] font-bold "
                  onClick={handlePopup}
                >
                  닫기
                </Button>
              </div>
            </div>
          </div>
        )}
    </>
  )
}
